import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const component: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 1,
        rows: 2,
        rowsSize: [1, 5],
        components: [
          [
            [
              {
                variant: "blockContainer",
                data: {
                  block: {
                    type: "audioButton",
                    options: {
                      text: "Symphony Orchestra",
                      theme: "secondary",
                      shape: "round",
                      icon: "cis-volume-high",
                      url: `${config.ASSETS_URL}/05/14/principle/optimisation-2-nart-orchestra.wav`,
                    },
                  },
                  styles: {
                    justifyContent: "flex-end",
                  },
                },
              },
              {
                variant: "blockContainer",
                data: {
                  block: {
                    type: "audioButton",
                    options: {
                      text: "Amplified Rock music",
                      theme: "secondary",
                      shape: "round",
                      icon: "cis-volume-high",
                      url: `${config.ASSETS_URL}/05/14/principle/optimisation-2-nart-rock.wav`,
                    },
                  },
                  styles: {
                    justifyContent: "flex-start",
                  },
                },
              },
            ],
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/14/principle/optimisation-2-nart.svg`,
                  },
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default component;
